<template>
  <b-modal id="entities_form_modal" ref="bvModal" :no-close-on-backdrop="true">
    <template v-slot:modal-header="{ close }">
      <div class="modal-header-buttons-container">
        <h2>{{ modalTitle }}</h2>
      </div>
    </template>
    <div class="modal-fields">
      <div class="modal-body-section">
        <div class="modal-inputs-holder">
          <div class="form-groups-container">
            <div class="bb-form-group">
              <label>{{ $t("legalEntityFormModal.firmName.label") }}</label>
              <input
                class="bb-input"
                type="text"
                v-model="form.fields.firmName"
              />
              <div class="bb-invalid-feedback" v-show="form.errors.firmName">
                {{ $t("legalEntityFormModal.validation.error") }}
              </div>
            </div>
            <div class="bb-form-group bb-legal-form-options">
              <label>{{ $t("legalEntityFormModal.legalForm.label") }}</label>
              <BBSelect
                :options="legalFormOptions"
                v-model="form.helpers.legalForm"
              ></BBSelect>
              <div class="bb-invalid-feedback" v-show="form.errors.legalForm">
                {{ $t("legalEntityFormModal.validation.error") }}
              </div>
            </div>
          </div>
          <div class="form-groups-container">
            <div class="bb-form-group">
              <label>{{
                $t("legalEntityFormModal.identificationNumber.label")
              }}</label>
              <input
                class="bb-input"
                type="text"
                v-model="form.fields.identificationNumber"
              />
              <div
                class="bb-invalid-feedback"
                v-show="form.errors.identificationNumber"
              >
                {{ $t("legalEntityFormModal.validation.error") }}
              </div>
            </div>
            <div class="bb-form-group">
              <label>{{
                $t("legalEntityFormModal.taxpayerNumber.label")
              }}</label>
              <input
                class="bb-input"
                type="text"
                v-model="form.fields.taxpayerNumber"
              />
              <div
                class="bb-invalid-feedback"
                v-show="form.errors.taxpayerNumber"
              >
                {{ $t("legalEntityFormModal.validation.error") }}
              </div>
            </div>
          </div>
          <div class="form-groups-container">
            <div class="bb-form-group">
              <label>{{ $t("legalEntityFormModal.emailInput.label") }}</label>
              <input
                class="bb-input"
                type="email"
                v-model="form.fields.email"
              />
              <div class="bb-invalid-feedback" v-show="form.errors.email">
                {{ $t("legalEntityFormModal.validation.error") }}
              </div>
            </div>
            <div class="bb-form-group">
              <label>{{ $t("legalEntityFormModal.phoneInput.label") }}</label>
              <input class="bb-input" type="text" v-model="form.fields.phone" />
              <div class="bb-invalid-feedback" v-show="form.errors.phone">
                {{ $t("legalEntityFormModal.validation.error") }}
              </div>
            </div>
          </div>
          <div class="bb-form-group">
            <label>{{
              $t("legalEntityFormModal.sendNotificationsByInput.label")
            }}</label>
            <BBSelect
              :options="sendNotificationsOptions"
              v-model="form.helpers.notificationsSentBy"
            ></BBSelect>
            <div
              class="bb-invalid-feedback"
              v-show="form.errors.notificationsSentBy"
            >
              {{ $t("legalEntityFormModal.validation.error") }}
            </div>
          </div>
          <div class="bb-form-group">
            <BBCheckbox
              v-model="form.fields.marketingNotificationsEnabled"
              :label="
                $t('legalEntityFormModal.notificationsEnabledInput.label')
              "
            />
            <div
              class="bb-invalid-feedback"
              v-show="form.errors.marketingNotificationsEnabled"
            >
              {{ $t("legalEntityFormModal.validation.error") }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body-section">
        <div class="modal-inputs-holder">
          <div>
            <div class="bb-form-group">
              <label>{{ $t("legalEntityFormModal.addressInput.label") }}</label>
              <input
                type="text"
                class="bb-input"
                v-model="form.fields.address"
              />
              <div class="bb-invalid-feedback" v-show="form.errors.address">
                {{ $t("legalEntityFormModal.validation.error") }}
              </div>
            </div>
            <div class="form-groups-container">
              <div class="bb-form-group">
                <label>{{ $t("legalEntityFormModal.cityInput.label") }}</label>
                <input
                  class="bb-input"
                  type="text"
                  v-model="form.fields.city"
                />
                <div class="bb-invalid-feedback" v-show="form.errors.city">
                  {{ $t("legalEntityFormModal.validation.error") }}
                </div>
              </div>
              <div class="bb-form-group">
                <label>{{
                  $t("legalEntityFormModal.zipCodeInput.label")
                }}</label>
                <input
                  type="text"
                  class="bb-input"
                  v-model="form.fields.zipCode"
                />
                <div class="bb-invalid-feedback" v-show="form.errors.zipCode">
                  {{ $t("legalEntityFormModal.validation.error") }}
                </div>
              </div>
            </div>
            <div class="bb-form-group">
              <label>{{ $t("legalEntityFormModal.notesInput.label") }}</label>
              <b-form-textarea
                rows="3"
                class="bb-textarea"
                v-model="form.fields.note"
              ></b-form-textarea>
              <div class="bb-invalid-feedback" v-show="form.errors.note">
                {{ $t("legalEntityFormModal.validation.error") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{ close }">
      <div class="footer-right">
        <button
          class="bb-btn btn-outline"
          id="close_legal_entity_modal"
          @click="close()"
        >
          {{ $t("legalEntityFormModal.closeBtn") }}
        </button>
        <button class="bb-btn btn-success" @click="submit()">
          {{ $t("legalEntityFormModal.saveBtn") }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import legalEntityForm from "@/core/services/forms/legalEntityForm.js";
import formMixin from "@/core/mixins/formMixin.js";
import BBSelect from "@/view/content/BBForm/BBSelect.vue";
import BBCheckbox from "@/view/content/BBForm/BBCheckbox.vue";
import i18nService from "@/core/services/i18n.service.js";
import moment from "moment";
import { SET_ALERT_MESSAGES } from "@/core/services/store/alert.module.js";
import { GET_LEGAL_ENTITIES } from "@/core/services/store/legal_entities.module";
import { EventBus } from "@/core/services/event-bus.js";

export default {
  name: "ClientFormModal",
  props: {
    perPage: {
      type: Number,
    },
    pageNumber: {
      type: Number,
    },
  },
  mixins: [formMixin],
  components: {
    BBSelect,
    BBCheckbox,
  },
  emits: ["entityCreated", "entityUpdated"],
  data() {
    return {
      legalFormOptions: [
        {
          text: this.$t("legalEntityFormModal.legalForm.options.entrepreneur"),
          value: "ENTREPRENEUR",
        },
        {
          text: this.$t("legalEntityFormModal.legalForm.options.llc"),
          value: "LLC",
        },
        {
          text: this.$t("legalEntityFormModal.legalForm.options.partnership"),
          value: "PARTNERSHIP",
        },
        {
          text: this.$t(
            "legalEntityFormModal.legalForm.options.limitedPartnership"
          ),
          value: "LIMITED_PARTNERSHIP",
        },
        {
          text: this.$t("legalEntityFormModal.legalForm.options.stockCompany"),
          value: "STOCK_COMPANY",
        },
      ],
      sendNotificationsOptions: [
        {
          text: this.$t(
            "legalEntityFormModal.sendNotificationsByInput.options.email"
          ),
          value: "email",
        },
        {
          text: this.$t(
            "legalEntityFormModal.sendNotificationsByInput.options.dontSend"
          ),
          value: "dont_send",
        },
      ],
    };
  },
  beforeMount() {
    // Get form object from legalEntityForm service
    this.form = JSON.parse(JSON.stringify(legalEntityForm));
    // Set moment locale
    moment.locale(i18nService.getActiveLanguage());
  },
  methods: {
    /**
     * Show the modal
     * @return {void}
     */
    show() {
      this.$refs.bvModal.show();
    },
    /**
     * Close the modal
     * @return {void}
     */
    closeModal() {
      document.querySelector("#close_legal_entity_modal").click();
    },

    /**
     * Update form fields from form helpers
     * @return {void}
     */
    updateFormFields() {
      this.form.helpers.notificationsSentBy == "email"
        ? (this.form.fields.bookingNotificationsEnabled = true)
        : (this.form.fields.bookingNotificationsEnabled = false);

      this.form.fields.legalForm = this.form.helpers.legalForm;

      if (this.form.mode == "edit") {
        this.form.path = this.form.path + "/" + this.form.fields.id;
      }
    },

    /**
     * Submit the form
     * @return {void}
     */
    submit() {
      this.updateFormFields();
      console.log(this.form);
      this.submitForm()
        .then((response) => {
          this.$store.dispatch(SET_ALERT_MESSAGES, {
            successMessages: [response.data.message],
            errorMessages: null,
          });
          if (this.form.mode == "edit") {
            this.closeModal();
            this.$emit("entityUpdated");
            this.$store.dispatch(GET_LEGAL_ENTITIES, {
              perPage: this.perPage,
              pageNumber: this.pageNumber,
            });
          } else {
            this.closeModal();
            this.$emit("entityCreated");
            this.$store.dispatch(GET_LEGAL_ENTITIES, {
              perPage: this.perPage,
              pageNumber: this.pageNumber,
            });
          }
        })
        .catch((error) =>
          this.$store.dispatch(SET_ALERT_MESSAGES, {
            successMessages: null,
            errorMessages: [error.response?.data.message],
          })
        );
    },

    /**
     * Delete the client
     * @return {void}
     */
    deleteClient() {
      let client = this.$store.getters.getClient(this.form.fields.id);

      EventBus.$emit("deletingClient", {
        client: client,
        successCallback: function () {
          document.querySelector("#entities_form_modal_close_btn").click();
          this.$store.dispatch(GET_LEGAL_ENTITIES);
        },
      });
    },
  },
  computed: {
    /**
     * Return modal title
     * @return {String}
     */
    modalTitle() {
      return this.form.mode === "edit"
        ? this.$t("legalEntityFormModal.editTitle")
        : this.$t("legalEntityFormModal.createTitle");
    },

    /**
     * Determine if left footer section is visible
     * @return {Boolean}
     */
    footerLeftVisible() {
      if (window.innerWidth < 992) {
        return this.form.mode === "edit";
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/bb-styles/modals/entities-form-modal.scss";
</style>
